<template>
  <div class="activity container">
    <div class="top_box">
      <div
        class="item"
        v-for="item in list"
        :key="item.id"
        @click="$router.push({ path: item.path, query: $route.query })"
      >
        <img :src="item.icon" alt="" />
        <p>{{ item.label }}</p>
      </div>
    </div>
    <div class="list_box">
      <el-tabs v-model="params.status" @tab-click="handleChange">
        <el-tab-pane label="未开始" name="PEND"></el-tab-pane>
        <el-tab-pane label="进行中" name="STARTED"></el-tab-pane>
        <el-tab-pane label="已结束" name="STOP"></el-tab-pane>
      </el-tabs>
      <el-table
        class="activities"
        :data="activities"
        height="calc(100% - 54px - 20px - 10px)"
        @row-click="goDetail"
      >
        <el-table-column type="index" width="50" align="center">
        </el-table-column>
        <el-table-column
          prop="type"
          label="活动类型"
          width="180"
          align="center"
          :formatter="formatter"
        >
        </el-table-column>
        <el-table-column
          prop="name"
          label="活动标题"
          :formatter="nameFormatter"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="100" align="center">
          <template slot-scope="scope">
            <el-button
              @click.native.stop="delRow(scope.row.activityId)"
              type="text"
              size="small"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          width="100"
          align="center"
          v-if="params.status != 'STOP'"
        >
          <template slot-scope="scope">
            <el-button
              @click.native.stop="handleOperate(scope.row)"
              type="primary"
              plain
              size="small"
            >
              {{ params.status == "PEND" ? "开始活动" : "结束活动" }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import {
  activityList,
  editActivity,
  delActivity,
} from "@/api/assistantMode/activity";

export default {
  name: "activity",
  data() {
    return {
      params: {
        classChapterId: this.$route.query.classChapterId,
        classId: this.$route.query.id,
        status: "PEND",
      },
      list: [
        {
          id: 1,
          icon: require("@/assets/images/icons/a_sign.png"),
          label: "签到",
          path: "/assistantMode/courseDetail/activity/sign",
        },
        {
          id: 2,
          icon: require("@/assets/images/icons/a_vote.png"),
          label: "投票",
          path: "/assistantMode/courseDetail/activity/vote",
        },
        {
          id: 3,
          icon: require("@/assets/images/icons/a_select.png"),
          label: "选人",
          path: "/assistantMode/courseDetail/activity/pick",
        },
        {
          id: 4,
          icon: require("@/assets/images/icons/a_question.png"),
          label: "抢答",
          path: "/assistantMode/courseDetail/activity/answer",
        },
        {
          id: 5,
          icon: require("@/assets/images/icons/a_disguss.png"),
          label: "主题讨论",
          path: "/assistantMode/courseDetail/activity/discuss",
        },
        {
          id: 6,
          icon: require("@/assets/images/icons/a_test.png"),
          label: "随堂练习",
          path: "/assistantMode/courseDetail/activity/quiz",
        },
        // {
        //   id: 7,
        //   icon: require("@/assets/images/icons/a_score.png"),
        //   label: "评分",
        //   path: "/assistantMode/courseDetail/activity/score",
        // },
      ],
      activities: [],
    };
  },
  activated() {
    this.getList();
  },
  methods: {
    // 活动列表
    getList() {
      this.params.classChapterId = this.$route.query.classChapterId;
      this.$loading.show();
      activityList(this.params).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.activities = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleChange() {
      this.getList();
    },
    formatter(row) {
      if (row.type == "SIGN") {
        return "签到";
      } else if (row.type == "TIMING_SIGN") {
        return "定时签到";
      } else if (row.type == "VOTE") {
        return "投票";
      } else if (row.type == "PICK") {
        return "选人";
      } else if (row.type == "ANSWER") {
        return "抢答";
      } else if (row.type == "DISCUSS") {
        return "主题讨论";
      } else if (row.type == "QUIZ") {
        return "随堂练习";
      } else if (row.type == "SCORE") {
        return "评分";
      }
    },
    nameFormatter(row) {
      let reg = /<\/?.+?\/?>/g;
      return row.name.replace(reg, "");
    },
    delRow(activityId) {
      this.$confirm(`确定要删除该活动吗？`, {
        type: "warning",
      })
        .then(() => {
          delActivity(activityId).then((res) => {
            if (res.code == 0) {
              this.$message.success(`删除成功`);
              this.getList();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    handleOperate(activity) {
      let text;
      if (activity.status == "PEND") {
        // 开始
        activity.status = "STARTED";
        text = "开始";
      } else {
        //结束
        activity.status = "STOP";
        text = "结束";
      }
      this.$confirm(`确定要${text}该活动吗？`, {
        type: "warning",
      })
        .then(() => {
          editActivity(activity).then((res) => {
            if (res.code == 0) {
              this.$message.success(`活动已${text}`);
              this.getList();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    // 详情
    goDetail({ activityId, type }) {
      let tail =
        this.params.status == "PEND" || type == "TIMING_SIGN" ? "" : "/detail";
      if (type == "TIMING_SIGN") type = "SIGN";
      this.$router.push({
        path: `/assistantMode/courseDetail/activity/${type.toLowerCase()}${tail}`,
        query: {
          activityId,
          ...this.$route.query,
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.activity {
  height: 100%;
  .top_box {
    margin: 30px 0 22px;
    padding: 20px 50px;
    background-color: #fff;
    .item {
      display: inline-block;
      padding: 0 52px;
      color: #1977f5;
      font-weight: bold;
      font-size: 16px;
      cursor: pointer;
      img {
        margin-bottom: 10px;
        width: 44px;
        height: 44px;
      }
    }
  }
  .list_box {
    padding: 10px 22px;
    background-color: #fff;
    height: calc(100% - 115px - 60px - 22px);
    ::v-deep .activities {
      margin-top: 10px;
      .is-leaf {
        color: #333;
        background-color: #f5f5f5;
      }
      .el-table__row {
        cursor: pointer;
      }
    }
  }
}
</style>